export default __webpack_public_path__ + "static/media/whatsapp-sender-icon.d5600644.svg";